var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoRecorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 7.44277C18.3332 6.93792 18.3332 6.6855 18.2333 6.56861C18.1467 6.46719 18.0168 6.41337 17.8838 6.42383C17.7306 6.43589 17.5521 6.61438 17.1951 6.97136L14.1665 9.99996L17.1951 13.0286C17.5521 13.3855 17.7306 13.564 17.8838 13.5761C18.0168 13.5866 18.1467 13.5327 18.2333 13.4313C18.3332 13.3144 18.3332 13.062 18.3332 12.5572V7.44277Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 8.16663C1.6665 6.76649 1.6665 6.06643 1.93899 5.53165C2.17867 5.06124 2.56112 4.67879 3.03153 4.43911C3.56631 4.16663 4.26637 4.16663 5.6665 4.16663H10.1665C11.5666 4.16663 12.2667 4.16663 12.8015 4.43911C13.2719 4.67879 13.6543 5.06124 13.894 5.53165C14.1665 6.06643 14.1665 6.76649 14.1665 8.16663V11.8333C14.1665 13.2334 14.1665 13.9335 13.894 14.4683C13.6543 14.9387 13.2719 15.3211 12.8015 15.5608C12.2667 15.8333 11.5666 15.8333 10.1665 15.8333H5.6665C4.26637 15.8333 3.56631 15.8333 3.03153 15.5608C2.56112 15.3211 2.17867 14.9387 1.93899 14.4683C1.6665 13.9335 1.6665 13.2334 1.6665 11.8333V8.16663Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorder);
export default __webpack_public_path__ + "static/media/video-recorder.07b4281297c64e48766c4a85b9747667.svg";
export { ForwardRef as ReactComponent };